/**
 * Still image for product cards and predictive search rows that have a Sirv
 * folder but no Shopify media. One directory lookup per folder. Cards wait
 * until they are near the screen. Does not start the Sirv viewer.
 */
(function () {
  var cache = {};
  var imageExt = /\.(jpe?g|png|webp|gif)(\?|#|$)/i;
  var spinExt = /\.spin(\?|#|$)/i;

  function absoluteUrl(href) {
    if (!href) return '';
    href = href.replace(/&amp;/g, '&');
    if (href.indexOf('//') === 0) return 'https:' + href;
    return href;
  }

  function firstFile(html) {
    var re = /<a\s+[^>]*href="([^"]+)"/gi;
    var match;
    var spin = '';
    while ((match = re.exec(html))) {
      var href = match[1];
      if (imageExt.test(href)) return absoluteUrl(href);
      if (!spin && spinExt.test(href)) spin = absoluteUrl(href);
    }
    return spin;
  }

  function stillUrl(fileUrl, width) {
    var join = fileUrl.indexOf('?') === -1 ? '?' : '&';
    var frame = spinExt.test(fileUrl) ? 'image.number=1&' : '';
    return fileUrl + join + frame + 'w=' + width + '&scale.option=fit&q=60&format=webp';
  }

  function show(img, src) {
    img.addEventListener('load', function () {
      var placeholder = img.parentElement && img.parentElement.querySelector('.card__sirv-placeholder, .sirv-still-placeholder');
      if (placeholder) placeholder.remove();
    }, { once: true });
    img.addEventListener('error', function () {
      img.remove();
    }, { once: true });
    img.src = src;
  }

  function load(img) {
    if (img.dataset.sirvState === 'loading' || img.dataset.sirvState === 'done' || img.dataset.sirvState === 'empty') return;
    img.dataset.sirvState = 'loading';
    var folder = img.getAttribute('data-sirv-folder');
    if (!folder) return;

    if (!cache[folder]) {
      cache[folder] = fetch(folder, { credentials: 'omit' })
        .then(function (res) {
          if (!res.ok) return null;
          var type = res.headers.get('content-type') || '';
          if (type.indexOf('text/html') === -1) return null;
          return res.text();
        })
        .then(function (html) {
          if (!html || html.indexOf('<tr>') === -1) return null;
          return firstFile(html) || null;
        })
        .catch(function () {
          return null;
        });
    }

    cache[folder].then(function (fileUrl) {
      if (!img.isConnected) return;
      if (!fileUrl) {
        img.dataset.sirvState = 'empty';
        img.remove();
        return;
      }
      var width = parseInt(img.getAttribute('data-sirv-width'), 10);
      if (!width || width < 1) width = 700;
      img.dataset.sirvState = 'done';
      show(img, stillUrl(fileUrl, width));
    });
  }

  function watch() {
    var imgs = document.querySelectorAll('img[data-sirv-folder]:not([data-sirv-state])');
    if (!imgs.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(imgs, load);
      return;
    }

    if (!window.__sirvCardIO) {
      window.__sirvCardIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          window.__sirvCardIO.unobserve(entry.target);
          load(entry.target);
        });
      }, { rootMargin: '250px' });
    }

    Array.prototype.forEach.call(imgs, function (img) {
      img.dataset.sirvState = 'queued';
      if (img.closest('.predictive-search, .predictive-result')) {
        load(img);
        return;
      }
      window.__sirvCardIO.observe(img);
    });
  }

  function boot() {
    watch();
    if (!document.body || document.body.dataset.sirvCardWatch === 'true') return;
    document.body.dataset.sirvCardWatch = 'true';

    var scheduled = false;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          if (scheduled) return;
          scheduled = true;
          window.requestAnimationFrame(function () {
            scheduled = false;
            watch();
          });
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('on:facet-filters:updated', watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
